import BreakShift from 'common/entity/components/dayShift/BreakShift';
import SingleBreakWithOffset from 'common/components/common/breaks/SingleBreakWithOffset';

import breakTabFactory from 'common/components/common/breaks/BreakTabFactory';

const BreakShiftTab = breakTabFactory({ SingleBreak: BreakShift });
export const BreakShiftTabWithOffset = breakTabFactory({
    SingleBreak: SingleBreakWithOffset
});

export default BreakShiftTab;
